import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import Select from 'react-select';
import { AppsFiltersStyles } from 'app/components/common/common-styles';

export const IsActiveAdapter: FilterAdapter<boolean> = {
  key: 'is_active',
  fromUrl: (sp) => {
    const raw = sp.get('is_active');
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (value === null || value === undefined) {
      next.delete('is_active');
    } else {
      next.set('is_active', String(value));
    }
    return next;
  },
  toKey: (v) => `active:${v === null || v === undefined ? 'all' : v ? 'true' : 'false'}`
};

export const IsActiveFilter = ({ placeholder = 'All statuses' }: { placeholder?: string }) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(IsActiveAdapter);
  const options = [
    { value: true, label: 'Active' },
    { value: false, label: 'Inactive' }
  ];
  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select
      isClearable
      isSearchable={false}
      styles={AppsFiltersStyles()}
      options={options}
      value={selected}
      placeholder={placeholder}
      onChange={(opt: any) => ctl.set(IsActiveAdapter, opt?.value ?? null)}
    />
  );
};
